import React from 'react';
import { NavLink, useLocation, Link } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/img/diginsight.png';

const Header = () => {
  const location = useLocation();


  // Get user data from localStorage
  const user = JSON.parse(localStorage.getItem('userData'));

  // Check if user is logged in and has a valid PasswordHash
  const email = user && user.email;

  // Check if the current path is "/dashboards"
  const isDashboardPage = location.pathname === '/dashboards' || location.pathname === '/OneDriveFile' || location.pathname === '/spss';
  const isRespondent = location.pathname === '/overallshares' || location.pathname === '/secondview' || location.pathname === '/paymentmethodviews'
    || location.pathname === '/brandshares' || location.pathname === '/digitalnondigital';
  return (
    <header className="header" id="header">
      <div className="logo-container">
        <Link to="/dashboards">
          <img src={logo} alt="Logo" className="logo" />
        </Link>
      </div>

      {/* Navigation Bar with Multiple Tabs */}
      <nav className="nav-tabs">
        <ul>
          {!isDashboardPage && isRespondent && (
            <>
              {/* <li>
                <NavLink to="/dashboards" 
  className={({ isActive }) => (isActive ? 'filter-button active' : 'filter-button')}>
                  Dashboard
                </NavLink>
              </li> */}
              <li>
                <NavLink to="/overallshares"
                  className={({ isActive }) => (isActive ? 'nav-button active' : 'nav-button')}>
                  <label>Overall Shares</label>
                </NavLink>
              </li>
              <li>
                <NavLink to="/secondview"
                  className={({ isActive }) => (isActive ? 'nav-button active' : 'nav-button')} >
                  <label>Total Shares by Form Factor & In-Person vs. Virtual</label>
                </NavLink>
              </li>
              <li>
                <NavLink to="/paymentmethodviews"
                  className={({ isActive }) => (isActive ? 'nav-button active' : 'nav-button')} >
                  <label>Payment Method Views</label>
                </NavLink>
              </li>
              <li>
                <NavLink to="/brandshares"
                  className={({ isActive }) => (isActive ? 'nav-button active' : 'nav-button')} >
                  <label>Brand Share</label>
                </NavLink>
              </li>
              <li>
                <NavLink to="/digitalnondigital"
                  className={({ isActive }) => (isActive ? 'nav-button active' : 'nav-button')} >
                  <label>Digital vs. Non-Digital</label>
                </NavLink>
              </li>
              {/* Conditionally show the "Upload" button if PasswordHash exists */}
              {email && (
                <>
                  <li>
                    <NavLink
                      to="/OneDriveFile"
                      className={({ isActive }) => (isActive ? 'filter-button active' : 'filter-button')}
                    >
                      <i className="fa fa-file"></i>
                      <span className="hover-text">Download Files</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/spss"
                      className={({ isActive }) => (isActive ? 'filter-button active' : 'filter-button')}
                    >
                      <i className="fa fa-upload"></i>
                      <span className="hover-text">Upload</span>
                    </NavLink>
                  </li>
                </>
              )}
            </>
          )}
          <li>
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? 'logout-button active' : 'logout-button')}
            >
              <span style={{color: 'white'}}>Log Out</span>&nbsp;&nbsp;
              <i className="fa fa-power-off" style={{ color: '#ffb200' }}></i>
            </NavLink>
          </li>


        </ul>
      </nav>
    </header>
  );
};

export default Header;
